/* eslint react/prop-types: 0 */
import React from 'react';
import { capitalize } from 'lodash';

import { formatSalePrice } from '../../utils/money';
import { sortByDate } from '../../utils/date';

import HorseCell from './components/HorseCell';
import SireCell from './components/SireCell';
import SalesHorseLink from '../../shared/links/SalesHorseLink';
import Abbr from '../../shared/Abbr';

const columns = [
    {
        key: 'saleDate',
        header: 'date',
        cell: SalesHorseLink,
        sortFn: sortByDate('saleDate'),
    },
    {
        key: 'horseName',
        header: () => (
            <Abbr title="horse" breakpoint="fromMedium">
                horse<br />
                sire (dam&apos;s sire)
            </Abbr>
        ),
        cell: HorseCell,
        sortFn: 'alphabetic',
    },
    {
        key: 'sireName',
        // using <abbr className="pp-abbr__from"> for A-QA comfort
        header: () => (
            <abbr className="pp-abbr__from">
                sire<br />dam&apos;s sire
            </abbr>
        ),
        cell: SireCell,
        sortFn: 'alphabetic',
    },
    {
        key: 'priceGbp',
        header: 'price',
        cell: ({ price, curCode }) => formatSalePrice(price, curCode),
    },
    {
        key: 'vendor',
        sortFn: 'alphabetic',
    },
    {
        key: 'buyerDetail',
        header: 'buyer',
        sortFn: 'byLastName',
    },
    {
        key: 'venueDesc',
        header: 'sale',
        cell: ({ venueDesc }) => capitalize(venueDesc).substr(0, 3),
        sortFn: 'alphabetic',
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/horse/progenySales/columns.jsx